




















import { defineComponent } from '@vue/composition-api'
import CommonModalSection from '@/components/common/modal/CommonModalSection.vue'
import ModalTitleParts from '@/components/common/modal/parts/ModalTitleParts.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'

/**
 * 共通 タイトル+slotモーダル テンプレート
 */
export default defineComponent({
  name: 'TitledModalSection',
  components: {
    CommonModalSection,
    ModalTitleParts,
    AtomInputButton,
  },
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
  },
  methods: {
    emitClose(): void {
      /**
       * closeModal
       * 親コンポーネントへ閉じる処理を通知
       */
      this.$emit('close')
    },
  },
})
